import React from 'react';
import Typography from '@material-ui/core/Typography';
import EarningStatistic from './EarningStatistic';
import {StatisticBox} from '../../../../components';
import {useGetMessages} from '../../../../hooks';
import {ConfigState} from '../../../../reducers/config';
import {Earnings} from '../../../../reducers/dashboard';
import styled from 'styled-components';

const CreatorCode = styled(Typography)`
    width: 100%;
    text-transform: uppercase;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 400 !important;

    ${p => p.theme.muiTheme.breakpoints.up('lg')} {
        font-size: 27px !important;
    }
`;

export interface MyCreatorCodeProps {
    isRendering?: boolean;
    earnings: Earnings;
    creatorCode: string;
    configState: ConfigState;
}

const MyCreatorCode: React.FC<MyCreatorCodeProps> = ({
    isRendering = false,
    creatorCode = 'N/A',
    configState
}) => {
    const {quickLinks = {}} = configState || {};

    const messages = useGetMessages({
        creatorCode: 'epic.affiliate.earnings.my_creator_tag.title.v2',
        changeCreatorCode: {
            code: 'epic.affiliate.ccss.changeRedirect',
            args: [quickLinks.changeCreatorCode]
        }
    });

    return (
        <EarningStatistic
            isRendering={isRendering}
            title={messages.creatorCode}
            tipTitle={<span dangerouslySetInnerHTML={{__html: messages.changeCreatorCode}} />}>
            <StatisticBox
                isRendering={isRendering}
                header={<CreatorCode variant="h2">{creatorCode}</CreatorCode>}
                CardHeaderProps={{disableTypography: true}}
            />
        </EarningStatistic>
    );
};

export default MyCreatorCode;
